import createValidationFn from '@gef-ui/form-core/validations/createValidationFn';
import { onlyAllowedCharsDisjoint } from '@gef-ui/form-core/validations/validationFunctions/text';

import { regexMunicipality } from '../constants';
import { isLength } from './common';

const minLength = isLength({
	minLength: 2,
	maxLength: 55,
	minLengthMessageKey: 'validation:lengthBetweenScope',
});

const allowedChars = onlyAllowedCharsDisjoint({
	regex: new RegExp(regexMunicipality),
	messageKey: 'validation:allowedCharactersMunicipality',
});

export default createValidationFn(() => (args) => {
	const { fieldValue } = args;
	if (!fieldValue) {
		return null;
	}

	return allowedChars.validate(args)?.errorMessage || minLength.validate(args)?.errorMessage;
});
